var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.recommendations?.length)?_c(_setup.Stack,{attrs:{"gap":"2"}},_vm._l((_vm.recommendations),function(rec,index){return _c(_setup.Callout,{key:index,attrs:{"status":_setup.getPriorityStatus(rec.priority),"icon":'fas fa-' + rec.icon}},[_vm._v("\n    "+_vm._s(rec.message)+"\n  ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }